import gsap from "gsap";
import { ISkeletonData, Spine } from "pixi-spine";
import * as PIXI from "pixi.js";
import { Container, DisplayObject } from "pixi.js";
import { LineWin, PlayWindow } from "../../api";
import { IChangeableInterval, Interval } from "../../Context/Interval";
import { Color, CreateSpineResources, LogGroup, Rect, Size } from "../../MyHelpers";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { Settings } from "../../Settings";
import { ISpinnableReels } from "../SpinAnimation/SpinnableReels";
import { WinLineMarkersPIXIAPP } from "../WinLineMarkersPIXIAPP";
import { GenericWinLinesAnimationPIXIAPP, WinLinesAnimationParams, WinLinesTypeStyle } from "./GenericWinLinesAnimation";

export interface WinSquareAnimationsParamsSpinePIXIAPP {
	readonly index: number,
	//readonly sprite: ISprite,
	readonly symbolSize: Size,
	readonly spinnableReels: ISpinnableReels,
	//readonly texturePIXIAPP : PIXI.Texture[]
}

export class WinSquareAnimationsElementsSpinePIXIAPP {
	//protected view: HTMLElement;
	protected symbolSize: Size;
	//protected sprite: ISprite;
	//protected sprCanvas: CanvasSprite;
	protected currentSquareIndex: number = 0;
	protected lineDuration: number = 250;
	protected index: number;

	protected newScaleX: number = 1.05;
	protected newScaleY: number = 1.10;

	//protected columCoordinate: number = 0;
	//protected rowCoordinates: number[] = [];lra

	protected rects: Rect[] = [];

	protected viewPIXIAPP : PIXI.Container = null;
	//protected animatedSprite : PIXI.AnimatedSprite = null;
	public constructor(params: WinSquareAnimationsParamsSpinePIXIAPP) {
		this.index = params.index;
		this.symbolSize = params.symbolSize;
		//this.sprite = params.sprite;
		//let scale: number = 1.25;
		//let symbolSize: Size = spinnableReels.GetSymbolSize();

		// square should match symbol size
		//this.sprCanvas = new CanvasSprite({sprite: this.sprite, canvasSize: params.spinnableReels.GetSymbolSize().Scale(this.newScale)});
		//this.sprCanvas.Scale(scale);
		//this.sprCanvas.Start(true);

		let columnCenterx = params.spinnableReels.GetSymbolRect(params.index, 0).centerx;

		for (let row = 0; row < params.spinnableReels.GetWindowSymbolSize().Height; row++) {
			let rowCenterY = params.spinnableReels.GetSymbolRect(params.index, row).centery;

			let r = new Rect(
				columnCenterx - (this.symbolSize.Width / 2),
				rowCenterY - (this.symbolSize.Height / 2),
				this.symbolSize.Width,
				this.symbolSize.Height
			).Scale(this.newScaleX, this.newScaleY);

			this.rects.push(r);
		}


		// default position before first "play"
		let defaultRect: Rect = this.rects[0];


		// this.view = document.createElement("div");
		// this.view.classList.add("SquareAnim" + this.index);
		// this.view.style.boxSizing = "border-box";
		// //this.view.appendChild(this.sprCanvas.View());
		// this.view.style.position = "absolute";
		// this.view.style.top = "0px";
		// this.view.style.left = "0px"; // always the same column
		// this.view.style.width = this.symbolSize.Scale(this.newScale).width + "px";
		// this.view.style.height = this.symbolSize.Scale(this.newScale).height + "px";
		// this.view.style.zIndex = "" + ZIndex.WinLines;

		// TweenLite.set(this.view, { x: defaultRect.x, y: defaultRect.y });



		// just debug stuff
		//this.view.style.visibility = "hidden";
		//this.view.style.border = "5px solid red";
		
		// this.viewPIXIAPP = new PIXI.Container();
		// this.viewPIXIAPP.position.set(0,0);
		// this.viewPIXIAPP.width = this.symbolSize.Scale(this.newScale).width;
		// this.viewPIXIAPP.height = this.symbolSize.Scale(this.newScale).height;

		// gsap.set(this.viewPIXIAPP, { x: defaultRect.x, y: defaultRect.y });
		
		// this.animatedSprite = new PIXI.AnimatedSprite(params.texturePIXIAPP);
		// this.animatedSprite.animationSpeed = 0.5;
		// this.animatedSprite.width = this.symbolSize.Scale(this.newScale).width;
		// this.animatedSprite.height = this.symbolSize.Scale(this.newScale).height;
		// //this.animatedSprite.gotoAndPlay(0);		
		// this.viewPIXIAPP.visible = false;

		// this.viewPIXIAPP.addChild(this.animatedSprite);
		
	}

	public View(): HTMLElement {
		return null;
	}

	protected isOnLoop : boolean = false ;
	public Start(symbolRow: number, firstShowing: boolean) {
		if(!this.isOnLoop)this.spine?.state?.setAnimation(0,"animation",true);
		this.isOnLoop = true;
		//here we can animate to move to new position
		let rect = this.rects[symbolRow];
		let params = { x: rect.x, y: rect.y };

		// first line show right away, next lines animate
		if (firstShowing) {
			//TweenLite.set(this.view, params);
			gsap.set(this.viewPIXIAPP,{ x: rect.x, y: rect.y });
		}
		else {
			//TweenLite.to(this.view, 0.125, params);
			gsap.set(this.viewPIXIAPP, {duration : 0.125, x: rect.x, y: rect.y });
		}

		//this.view.style.visibility = "";		
		//this.animatedSprite.gotoAndPlay(0);
		this.viewPIXIAPP.visible = true;

		// restart, so sprites are in sync
		//this.sprCanvas.Restart(true);
		
		
	}

	public Stop(): void {
		//this.view.style.visibility = "hidden";
		//this.sprCanvas.Stop();

		this.spine?.state?.clearTracks();
		this.spine?.skeleton?.setBonesToSetupPose();
        this.spine?.skeleton?.setToSetupPose();
        this.spine?.skeleton?.setSlotsToSetupPose();
		this.spine?.state?.update(0);
        this.spine?.update(0);
		this.viewPIXIAPP.visible = false;		
		//this.animatedSprite.stop();
		this.isOnLoop = false;

	}

	public Update() {
		//this.sprCanvas.Update();
	}
	
	// public ViewPIXIAPP(): PIXI.Container{
	// 	return this.viewPIXIAPP;
	// }
	protected spine : Spine = null;
	public CreatePIXIAPP(jsonSpine : ISkeletonData){
	


		this.viewPIXIAPP = new PIXI.Container();
		this.viewPIXIAPP.position.set(0,0);
		this.viewPIXIAPP.width = this.symbolSize.Scale(this.newScaleX).Width;
		this.viewPIXIAPP.height = this.symbolSize.Scale(this.newScaleY).Height;
		//put default position 
		gsap.set(this.viewPIXIAPP, { x: this.rects[0].x, y: this.rects[0].y });			
		this.viewPIXIAPP.visible = false;

		//create Spine 
		this.spine = CreateSpineResources(jsonSpine);		
		this.spine.width = this.symbolSize.Scale(this.newScaleX).Width;
		this.spine.height = this.symbolSize.Scale(this.newScaleY).Height;
		this.spine.state.timeScale = 1;
		this.viewPIXIAPP.addChild(this.spine);
		

		return this.viewPIXIAPP;
	}
}

export class WinSquaresAnimationsSpinePIXIAPP extends GenericWinLinesAnimationPIXIAPP{	
	//protected sprite: Sprite;
	protected logGroup: LogGroup;
	protected spinnableReels: ISpinnableReels;
	protected resid: ResourceIdentifier;
	protected symbolSize: Size;
	protected viewSize: Size;
	protected slotWindow: Rect = null;
	protected slotWindowSymbolSize: PlayWindow = null;
	protected elements: WinSquareAnimationsElementsSpinePIXIAPP[] = [];
	//protected view: HTMLElement;
	protected lines: number[][];
	protected squareDuration: number = 250;

	protected commonResourcesBasePath: String = Settings.ResourcesFolder + "multigame/slot/common/";


	protected resultLines: LineWin[];
	protected currentResultLineIndex: number = 0;
	protected nextLineInterval: IChangeableInterval = null

	protected readonly animateOnlyWinningSymbols: boolean = true;
	//Create Markers for win Lines
	protected winLineMarkers: WinLineMarkersPIXIAPP = null;
	protected running: boolean = false;

	//create view pixi app 
	protected viewPIXIAPP : PIXI.Container = null;
	protected gameName : string = "";
	//constructor(viewSize: Size, slotWindow: PixelRect, slotWindowSymbolSize:Size, spinnableReels: SpinnableReels, logGroup: LogGroup, resid: ResourceIdentifier)
	protected winLinesTypeStyle : WinLinesTypeStyle = null
	constructor(params: WinLinesAnimationParams) {
		super();
		this.viewSize = params.viewSize;
		this.spinnableReels = params.spinnableReels;
		this.logGroup = params.logGroup.Add("WinSquaresSpinePIXIAPPAnimation");
		this.resid = params.resid.Add("WinSquaresSpinePIXIAPPAnimation");
		this.slotWindow = params.spinnableReels.GetWindowRect();
		this.slotWindowSymbolSize = params.spinnableReels.GetWindowSymbolSize();

		this.symbolSize = params.spinnableReels.GetSymbolSize();

		this.lines = params.lines;
	
		this.nextLineInterval = new Interval(this.resid, () => this.NextLine(), 2000);
		this.winLineMarkers = new WinLineMarkersPIXIAPP(params.slotWindow, Size.FromPlayWindow(this.spinnableReels.GetWindowSymbolSize()), this.lines, params.spinnableReels.GetSymbolSize());
		this.squareDuration = params.speedFactorAnimation;
		this.gameName = params.gameName;
		this.winLinesTypeStyle = params.winLinesTypeStyle;
	}

	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//resourceManager.AddGlobal(new SpriteResource(this.commonResourcesBasePath + "resources/neonsquare", ResourceIdentifier.Global.Add("neonsquare").Add("neonsquare"), true, this.logGroup.Add("neonsquare"), true));

		let bonusResorucesSpine : string = `${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine//WinLines/SquareWinLines/SquareWinLines`; 		
		if(this.winLinesTypeStyle == WinLinesTypeStyle.gameStyle ) bonusResorucesSpine = `${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/SpineResources/SquareWinLines/SquareWinLines` 
		//Spine Prepare 				
		resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}.json`,this.resid.ScopedResourceName(`WinSquaresSpinePIXIAPPAnimationJSON`)));
		resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}.atlas`, this.resid.ScopedResourceName(`WinSquaresSpinePIXIAPPAnimationATLAS`)));

	}

	//protected texturePIXIAPP: PIXI.Texture[] = [];
	protected jsonSpine: ISkeletonData = null
	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

		let spineTextureJson = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`WinSquaresSpinePIXIAPPAnimationJSON`));
		let spineAsset = await PIXI.Assets.load(spineTextureJson.path);
		this.jsonSpine = spineAsset.spineData;
		

		let numberOfColumns = this.spinnableReels.GetWindowSymbolSize().Width;
		for (let i = 0; i < numberOfColumns; i++) {
			let params: WinSquareAnimationsParamsSpinePIXIAPP = {
				index: i,
				//sprite: this.sprite.Copy(),
				symbolSize: this.spinnableReels.GetSymbolSize(),
				spinnableReels: this.spinnableReels,				
			}
			// create Element
			let element = new WinSquareAnimationsElementsSpinePIXIAPP(params);

			// save element to array
			this.elements.push(element);			
		}

	}


	public Start(resultLines: LineWin[], duration: number): void {

		this.running = true;

		if (resultLines.length > 0) {
			// Log.Debug(this.logGroup, "Start");			
			this.squareDuration = duration;
			this.resultLines = resultLines;
			this.currentResultLineIndex = 0;

			// TODO use duration for interval!
			this.nextLineInterval.ChangeInterval(this.squareDuration);
			this.nextLineInterval.Start();

			// show first line right await
			this.NextLine();
		}
	}

	protected Stop(interrupted: boolean) {
		this.running = false;
		this.nextLineInterval.Stop();
		for (let column = 0; column < this.elements.length; column++) {
			this.elements[column]?.Stop();
		}
		this.winLineMarkers.Hide();

		this.OnComplete(interrupted);
	}


	protected NextLine() {

		// check if any lines remaining
		// if not, stop the interval and hide squares
		
		if (this.currentResultLineIndex >= this.resultLines.length) {			
			this.Stop(true);
			return;
		}

		// show current line
		let currentResultLine: LineWin = this.resultLines[this.currentResultLineIndex];

		// this holds rows for each column 0, 1, 2, 1, 0
		let currentLine: number[] = this.lines[currentResultLine.LineIndex];

		// Log.Debug(this.logGroup, "Showing line " + this.currentResultLineIndex, currentLine);

		let symbols = currentResultLine.SymbolCount;
		let column = 0

		// show only first symbols
		for (; column < symbols; column++) {
			let row = currentLine[column];

			// here we would tell to what row it should move that particular square
			this.elements[column].Start(row, this.currentResultLineIndex == 0);
		}

		// hide remaining squares
		for (; column < this.elements.length; column++) {
			this.elements[column].Stop();
		}


		if (this.currentResultLineIndex == 0) {
			this.OnStartLine(currentResultLine, Color.FromRGBA(0xDA, 0xAF, 0x37, 0x01), this.animateOnlyWinningSymbols);
			this.winLineMarkers.Show(currentResultLine.LineIndex,Color.FromRGBA(0xDA, 0xAF, 0x37, 0x01))
		}

		this.OnNextLine(currentResultLine, Color.FromRGBA(0xDA, 0xAF, 0x37, 0x01), this.animateOnlyWinningSymbols);
		this.winLineMarkers.Show(currentResultLine.LineIndex,Color.FromRGBA(0xDA, 0xAF, 0x37, 0x01))
		

		this.currentResultLineIndex++;

		//console.log(`Drawing line: ${this.currentResultLineIndex}/${this.resultLines.length}`);

	}

	public RequestStop(): void {
		this.Stop(true);
	}

	// TODO need to check...
	// do we even need that?
	// we have "OnComplete" callback, that signals when its complete
	public GetDuration(): number {
		return this.resultLines.length * this.squareDuration;;
	}

	public Update(): void {
		// update sprites, when running
		if (this.running)
		{
			for (let i = 0; i < this.elements.length; i++) {
				this.elements[i].Update();
			}
		}
	}

	public View(): HTMLElement {
		return null;
	}
	
	public ViewPIXIAPP(): Container<DisplayObject> {
		return this.viewPIXIAPP;
	}

	public override CreatePIXIAPP(containerPIXI : PIXI.Container) {
		//create view for everything 
		
		this.viewPIXIAPP = new PIXI.Container();
		this.viewPIXIAPP.width = this.viewSize.Width;
		this.viewPIXIAPP.height = this.viewSize.Height;
		this.viewPIXIAPP.name = "WinSquaresAnimation";
		//this.viewPIXIAPP.position.set(0, Settings.ScreenHeight * (Settings.Screens - 1));
		this.elements.forEach((element)=>{		
			if(containerPIXI != null) containerPIXI.addChildAt(element.CreatePIXIAPP(this.jsonSpine),1);
			else this.viewPIXIAPP.addChild(element.CreatePIXIAPP(this.jsonSpine));
		});
		//create markes for show win line hit
		let containerWinLineMarkers = this.winLineMarkers.CreateViewAPP();
		 containerWinLineMarkers.forEach((ele)=>{			
			this.viewPIXIAPP.addChild(ele);
		});

		//if(containerPIXI != null) containerPIXI.addChildAt(this.viewPIXIAPP,1);
	}
}